interface Review {
  id: string;
  user: string;
  avatar: string;
  rating: number;
  comment: string;
  date: string;
}

interface FactoryReviewsProps {
  reviews: Review[];
  rating: number;
  totalReviews: number;
}

export default function FactoryReviews({ reviews, rating, totalReviews }: FactoryReviewsProps) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 mt-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-extrabold text-gray-900">Factory Reviews</h2>
        <div className="flex items-center gap-2">
          <div className="flex gap-0.5">
            {[1,2,3,4,5].map((s) => (
              <i key={s} className={`text-sm ${s <= Math.floor(rating) ? "ri-star-fill text-yellow-400" : "ri-star-line text-gray-300"}`} />
            ))}
          </div>
          <span className="text-sm font-bold text-gray-900">{rating}</span>
          <span className="text-sm text-gray-400">({totalReviews.toLocaleString()} reviews)</span>
        </div>
      </div>

      <div className="space-y-4">
        {reviews.map((review) => (
          <div key={review.id} className="flex gap-3 pb-4 border-b border-gray-50 last:border-0 last:pb-0">
            <img src={review.avatar} alt={review.user} className="w-10 h-10 rounded-full object-cover flex-shrink-0" />
            <div className="flex-1">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-semibold text-gray-900">{review.user}</span>
                <span className="text-xs text-gray-400">{review.date}</span>
              </div>
              <div className="flex gap-0.5 mb-1.5">
                {[1,2,3,4,5].map((s) => (
                  <i key={s} className={`text-xs ${s <= review.rating ? "ri-star-fill text-yellow-400" : "ri-star-line text-gray-300"}`} />
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">{review.comment}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
